
<template>
  <div >
    <div class="page-detail">
      <soft-iteam v-for="soft in softs" v-bind:data2=soft ></soft-iteam>

      <!-- <li v-for="menu in menus">  
          <router-link v-bind:to="{ path: menu.path}" active-class="select">{{menu.tittle}}</router-link>
        </li> -->
    </div>
    <pannel-foot></pannel-foot>

  </div>
</template>

<script>
import SoftIteam from './control/SoftIteam.vue'
import PannelFoot from './PannelFoot.vue';
export default {
  name: 'PannelHome',
  components: { SoftIteam, PannelFoot },
  props: {
    // soft: String,
  },
  data () {
    return {
      visible: true,
      msg: 'Welcome to Your Vue.js App',
      softs:
      [
        // {tittle: "标题1", content:"说明信息说明信息说明信息说明信息1", size:"200KB", image:"../../assets/0.png"},
        // {tittle: "标题2", content:"说明信息说明信息说明信息说明信息2", size:"200KB", image:"../../assets/0.png"},
      ],
      query: {
        key:"*", 
        list: "true",
      },

    }
  },

  mounted()
  {
    // this.soft = this.$route.params.soft;
  },
  created()
  {
    if ( typeof(this.$route.query.key) != "undefined" )
    {
      this.query = this.$route.query;
      // console.log("query参数：" + JSON.stringify(this.query));
    }

    var that = this;
    
    this.$CheckToolBox((haveToolBox)=>{

      // this.soft = this.$route.query.id;
      // this.$router.push({ path: '/soft', query: { id: 'easyicon' }});

      // this.soft = this.$route.params.id;
      // this.$router.push({ name: '/soft', params: { id: 'easyicon' }});
      
      // this.$http.get('http://localhost:44923/pages/SoftSearch.aspx?key=easyicon&list=true')
      // this.$http.get('/pages/SoftSearch.aspx', {params:{key: "*", list: "true"}})
      that.query.link = haveToolBox;
      this.$http.get('/pages/SoftSearch.aspx', {params: that.query})
      .then((response)=>{
        // console.log(response);
        if(response.data.status === "success")
        {
          that.softs = response.data.list;
        }
      })
      .catch((response)=>{
        console.log(response);
      })

    });
  },

  methods: {
    
    // // string转为base64
    // stringToBase64(str) {
    //   return new Buffer.from(str).toString("base64");
    // },

    // // base64转字符串
    // base64ToString(b64) {
    //   return new Buffer.from(b64, "base64").toString();
    // },
  }
  
  // watch: {
  //   // 监听路由是否变化
  //   '$route' (to, from) { 
  //     if(to.query.id != from.query.id){
  //         this.id = to.query.id; // 把最新id赋值给定义在data中的id
  //       this.init(); // 重新调用加载数据方法
  //     }
  //   }
  // },

}
</script>

<style scoped>

.page-detail {
    /* width: 95%; */
    width: 100%;
    text-align: center;
    min-width: 810px;
    /* margin: 0 auto; */
    margin: 30px;
    margin-left: auto;
}

/* .content p {
    word-wrap: break-word;
} */

a:hover {
    background-color: rgb(233,104,107);
}


</style>


// WEBPACK FOOTER //
// src/components/PannelHome.vue